/* Magix home: menu, copy buttons and the scroll-following hero headline for sections/magix-home.liquid. */
(function () {
  var root = document.querySelector('.magix-home');
  if (!root) return;

  /* ---------- Menu ---------- */
  var menuBtn = root.querySelector('#menuBtn'), menuList = root.querySelector('#menuList');
  function setMenu(open) {
    menuList.hidden = !open;
    menuBtn.setAttribute('aria-expanded', String(open));
    if (open) { var first = menuList.querySelector('a'); if (first) first.focus(); }
  }
  menuBtn.addEventListener('click', function (e) { e.stopPropagation(); setMenu(menuList.hidden); });
  menuList.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
  document.addEventListener('click', function (e) { if (!menuList.hidden && !e.target.closest('#menu')) setMenu(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menuList.hidden) { setMenu(false); menuBtn.focus(); } });

  /* ---------- Copy buttons ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-copy]'), function (btn) {
    btn.addEventListener('click', function () {
      var src = root.querySelector('#' + btn.getAttribute('data-copy'));
      if (!src) return;
      function done(ok) { btn.textContent = ok ? 'Copied' : 'Select to copy'; setTimeout(function () { btn.textContent = 'Copy'; }, 1800); }
      function selectIt() { var r = document.createRange(); r.selectNodeContents(src); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(src.textContent).then(function () { done(true); }, function () { selectIt(); done(false); });
      } else { selectIt(); done(false); }
    });
  });
})();

/* Hero headline follows the scroll: it stays pinned in view, then fades away
   as the next section's heading (Our work) comes up into the frame. */
(function () {
  var hero = document.querySelector('.mh-hero, .hero');
  var label = document.querySelector('#work .mh-section-label, #work .section-label') || document.querySelector('#mission .mh-section-label, #mission .section-label');
  if (!hero || !label) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var items = Array.prototype.slice.call(hero.querySelectorAll('.mh-eyebrow, .eyebrow, h1'));
  if (!items.length) return;
  var pin = 0, ticking = false;
  items.forEach(function (el) { el.style.willChange = 'transform, opacity'; });
  function update() {
    ticking = false;
    var vh = window.innerHeight, sy = window.pageYOffset || 0;
    var last = (hero.querySelector('h1') || items[items.length - 1]).getBoundingClientRect();
    var restBottom = last.bottom + sy - pin;            /* where the pinned text's bottom sits on screen */
    var fadeStart = vh, fadeEnd = Math.min(vh - 40, restBottom + 32);
    var top = label.getBoundingClientRect().top;
    var op = Math.max(0, Math.min(1, (top - fadeEnd) / Math.max(1, fadeStart - fadeEnd)));
    if (op > 0) pin = sy;
    items.forEach(function (el) {
      el.style.transform = pin ? 'translate3d(0,' + pin.toFixed(1) + 'px,0)' : '';
      el.style.opacity = op < 1 ? op.toFixed(3) : '';
      el.style.visibility = op === 0 ? 'hidden' : '';
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();

/* Our work montage: frames rise into place as they scroll into view, flow in
   and out of each other on wider screens, and each clip plays only while it is
   on screen. */
(function () {
  var grid = document.querySelector('.work-grid, .mh-work-grid');
  if (!grid) return;
  var frames = Array.prototype.slice.call(grid.querySelectorAll('.work-frame, .mh-work-frame'));
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  frames.forEach(function (f, i) {
    f.style.setProperty('--i', i);
    var v = f.querySelector('video');
    if (!v) return;
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
  });
  /* Mobile: the montage is a swipe carousel, with dots to show and pick the clip */
  var dots = document.createElement('div');
  dots.className = grid.classList.contains('mh-work-grid') ? 'mh-work-dots' : 'work-dots';
  dots.setAttribute('role', 'group'); dots.setAttribute('aria-label', 'Choose a project');
  frames.forEach(function (f, i) {
    var b = document.createElement('button');
    b.type = 'button'; b.setAttribute('aria-label', 'Project ' + (i + 1));
    b.addEventListener('click', function () { f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'start', block: 'nearest' }); });
    dots.appendChild(b);
  });
  grid.parentNode.insertBefore(dots, grid.nextSibling);
  var dotBtns = dots.querySelectorAll('button'), dotTick = false;
  function markDot() {
    dotTick = false;
    if (!frames.length) return;
    var step = frames[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(grid).columnGap) || 12);
    var at = Math.max(0, Math.min(frames.length - 1, Math.round(grid.scrollLeft / Math.max(step, 1))));
    if (grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4) at = frames.length - 1;
    for (var i = 0; i < dotBtns.length; i++) dotBtns[i].setAttribute('aria-current', i === at ? 'true' : 'false');
  }
  grid.addEventListener('scroll', function () { if (!dotTick) { dotTick = true; requestAnimationFrame(markDot); } }, { passive: true });
  markDot();
  /* Flowing montage: on wider screens the frames continually trade space,
     one growing as its neighbours shrink, all inside the page width */
  var wide = window.matchMedia('(min-width: 901px)');
  var flowing = false, seen = false, t0 = performance.now();
  function place(f, x, y, w, h) { f.style.left = x + 'px'; f.style.top = y + 'px'; f.style.width = w + 'px'; f.style.height = h + 'px'; }
  function layout(ms) {
    if (frames.length < 5) return;
    var W = grid.clientWidth, H = grid.clientHeight, g = parseFloat(getComputedStyle(grid).columnGap) || 14, s = ms / 1000;
    var split = H * (0.56 + 0.08 * Math.sin(s * 0.5));
    var h1 = split - g / 2, h2 = H - split - g / 2;
    var wa = (W - g) * (0.6 + 0.14 * Math.sin(s * 0.62 + 1.1));
    place(frames[0], 0, 0, wa, h1);
    place(frames[1], wa + g, 0, W - g - wa, h1);
    var k, wts = [], sum = 0;
    for (k = 0; k < 3; k++) { wts[k] = 1 + 0.45 * Math.sin(s * 0.55 + k * 2.094 + 0.4); sum += wts[k]; }
    var x = 0;
    for (k = 0; k < 3; k++) { var w = (W - 2 * g) * wts[k] / sum; place(frames[2 + k], x, split + g / 2, w, h2); x += w + g; }
  }
  function tick(now) { if (!flowing) return; layout(now - t0); requestAnimationFrame(tick); }
  function apply() {
    if (wide.matches && frames.length >= 5) {
      grid.classList.add('is-flow');
      layout(reduce ? 0 : performance.now() - t0);
      if (!reduce && seen && !flowing) { flowing = true; requestAnimationFrame(tick); }
      if (!seen) flowing = false;
    } else {
      flowing = false; grid.classList.remove('is-flow');
      frames.forEach(function (f) { f.style.left = f.style.top = f.style.width = f.style.height = ''; });
    }
  }
  if (wide.addEventListener) wide.addEventListener('change', apply); else if (wide.addListener) wide.addListener(apply);
  window.addEventListener('resize', function () { if (grid.classList.contains('is-flow') && !flowing) layout(reduce ? 0 : performance.now() - t0); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { seen = es[0].isIntersecting; apply(); }).observe(grid);
  } else { seen = true; }
  apply();
  if (!('IntersectionObserver' in window)) return;
  grid.classList.add('is-reveal');
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var f = e.target, v = f.querySelector('video');
      if (e.isIntersecting) {
        f.classList.add('is-in');
        if (v && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (v) { v.pause(); }
    });
  }, { threshold: 0.12 });
  frames.forEach(function (f) { io.observe(f); });
})();

/* Background showreels (opening section and Brand Solutions): a fast showreel
   of our work behind the section. With one dedicated clip it simply loops;
   with several it cuts between them every couple of seconds, each clip
   starting at a random moment and easing out of a slow zoom. Each reel plays
   only while its section is on screen. */
(function () {
  var wraps = document.querySelectorAll('.sol-reel, .mh-sol-reel');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  Array.prototype.forEach.call(wraps, function (wrap) {
    var vids = Array.prototype.slice.call(wrap.querySelectorAll('video'));
    if (!vids.length) return;
    var multi = vids.length > 1, i = multi ? Math.floor(Math.random() * vids.length) : 0, timer = null, running = false;
    vids.forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.loop = true;
      v.removeAttribute('autoplay'); v.removeAttribute('controls');
    });
    function load(v) { if (v.dataset.src && !v.getAttribute('src')) v.src = v.dataset.src; }
    function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function show(n) {
      vids.forEach(function (v, k) {
        if (k === n) {
          load(v);
          v.classList.remove('is-on'); void v.offsetWidth; v.classList.add('is-on');
          if (multi && v.duration > 4) { try { v.currentTime = Math.random() * (v.duration - 3); } catch (e) {} }
          v.playbackRate = multi ? 1.35 : 1;
          play(v);
        } else if (v.classList.contains('is-on')) {
          v.classList.remove('is-on');
          setTimeout(function () { if (!v.classList.contains('is-on')) v.pause(); }, 450);
        }
      });
      if (multi) load(vids[(n + 1) % vids.length]);
    }
    if (reduce) { load(vids[i]); vids[i].classList.add('is-on'); return; }
    function start() {
      if (running) return; running = true;
      show(i);
      if (multi) timer = setInterval(function () { i = (i + 1) % vids.length; show(i); }, 2100);
    }
    function stop() { running = false; clearInterval(timer); vids.forEach(function (v) { v.pause(); }); }
    var host = wrap.parentElement;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) start(); else stop(); }, { threshold: 0.08 }).observe(host);
    } else start();
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });
  });
})();
